import { useAppSelector } from "@/store/store";
import { useQuery } from "@tanstack/react-query";
import { getFormatInfosOptions } from "../queries/getFormatInfos";

export const useFormatInfos = () => {
    const imagesCount = useAppSelector((store) => store.imageUploader.images.length);
    const editorImagesCount = useAppSelector((store) => store.imageConverter.images.length);
    const formatInfosQuery = useQuery({
        ...getFormatInfosOptions(),
        enabled: imagesCount > 0 || editorImagesCount > 0,
    });
    return { formatInfosQuery };
};
